import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type CanvasKebabInteractionOption =
  | "delete"
  | "move"
  | "share"
  | "rename"
  | "change_owner";

export function useEmitCanvasKebabInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: CanvasKebabInteractionOption, canvasId?: string) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.CanvasKebab,
        optionSelected,
        customTrackingFields: {
          canvas_id: canvasId,
        },
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
